import React from 'react';
import ToolLayout from '../../components/ToolLayout';
import LoremIpsumGenerator from '../../components/LoremIpsumGenerator';

const LoremPage: React.FC = () => (
  <ToolLayout
    title="Lorem Ipsum Generator - Dummy Text | AllTools"
    description="Generate Lorem Ipsum placeholder text. Paragraphs, sentences, or words with HTML option. Free generator."
    canonicalPath="/lorem-ipsum-generator"
  >
    <LoremIpsumGenerator />
  </ToolLayout>
);

export default LoremPage;
